<script lang="ts">
  import { getContext } from 'svelte';
  const { close }: any = getContext('simple-modal');

  export let reopenedList: string[];
  export let responseMsg!: string;
</script>

<div class="h-auto p-6 bg-white m-auto max-w-4xl">
  <div class="mb-6">
    <div class="container flex justify-between">
      <h1 class="text-xl font-bold text-gray-700">決済方法変更</h1>
    </div>
  </div>

  <div class="shadow rounded-lg bg-gray-50 border-1 m-10 p-4">
    <div class="flex flex-col">
      <div class="flex-1">
        <div class="inline-flex justify-items-center items-center min-w-full p-4">
          <div class="justify-self-start w-full">
            <ul class="list-none">
              <li>
                <p>{responseMsg}</p>
              </li>
              {#if reopenedList.length}
                {#each reopenedList as reopened}
                  <li>
                    <p>{reopened}</p>
                  </li>
                {/each}
                <li>
                  <p>について、再開処理を行いました。</p>
                </li>
                <li>
                  <p>
                    ただし、当社からの請求について、お支払いが完了していないものが残っている場合、強制的に解約となりますのでご承知ください。
                  </p>
                </li>
              {/if}
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="mt-10 flex mx-auto justify-center">
    <button class="button-secondary" on:click={() => close()}>閉じる</button>
  </div>
</div>

<style lang="postcss">
  p {
    @apply tracking-normal mb-1;
  }
  .button-secondary {
    @apply bg-gray-300 rounded-lg hover:bg-gray-400 text-gray-500 focus:outline-none px-10 py-2;
  }
</style>
